import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import WaitJsLoaded from "../utils/WaitJsLoaded";
import { platform, isPlatformActive } from "../platform/getCurrentPlatform";
var extend = Object.assign;
var currentPlatformName = platform.name;
export default (function (pluginObj) {
  pluginObj = extend({
    platform: "all",
    methods: {}
  }, pluginObj);
  var _pluginObj = pluginObj,
      url = _pluginObj.url,
      methods = _pluginObj.methods,
      init = _pluginObj.init;
  var activePlatforms = pluginObj.platform;
  var methodsWrap = !!isPlatformActive(activePlatforms) ? function (method) {
    return function () {
      var _this = this;

      for (var _len = arguments.length, argv = new Array(_len), _key = 0; _key < _len; _key++) {
        argv[_key] = arguments[_key];
      }

      this._invokeCB(function () {
        return method.apply(_this, argv);
      });
    };
  } : function (method, scope) {
    return function () {
      return console.log("\u8BE5\u5E73\u53F0\u4E0D\u53EF\u7528");
    };
  };

  var Plugin = /*#__PURE__*/function (_WaitJsLoaded) {
    _inherits(Plugin, _WaitJsLoaded);

    var _super = _createSuper(Plugin);

    function Plugin(options) {
      var _this2;

      _classCallCheck(this, Plugin);

      return _this2 = _super.call(this, url, function () {
        init && init.apply(_assertThisInitialized(_this2));
      });
    }

    return Plugin;
  }(WaitJsLoaded);

  extend(Plugin.prototype, Object.keys(methods).reduce(function (obj, mName) {
    obj[mName] = methodsWrap(methods[mName]);
    return obj;
  }, {}));
  return Plugin;
});